<template>
    <div class="double-opt-in-demo">

        <h3 class="text-h5 mb-6">{{ heading }}</h3>

        <v-divider
            v-if="form_data.phone && form_data.phone_consent && conversation.length"
            class="mb-6"
        />

        <v-row justify="center">
            <v-col
                v-if="form_data.phone && form_data.phone_consent && conversation.length"
                cols="12"
                :lg="$slots['technical-notes'] ? 6 : 8"
            >
                <section
                    class="message-card mb-4"
                    aria-label="Sample text messages"
                >
                    <mock-text-conversation :messages="conversation" />
                </section>

                <v-divider
                    v-if="$vuetify.breakpoint.mdAndDown && $slots['technical-notes']"
                    class="mt-12"
                />
            </v-col>

            <v-col
                v-if="$slots['technical-notes']"
                cols="12"
                :lg="form_data.phone && form_data.phone_consent && conversation.length ? 6 : 8"
            >
                <section class="technical-notes pa-1 pa-lg-3 mt-6 mt-lg-0">
                    <h4 class="my-4">{{ technical_notes_heading }}</h4>

                    <slot name="technical-notes" />
                </section>
            </v-col>
        </v-row>

        <div class="countdown-container mt-4">
            <v-btn
                class="mt-6"
                color="primary"
                @click="$emit('reset-form')"
            >
                Reset Form
            </v-btn>
        </div>
    </div>
</template>

<script>
import MockTextConversation from '@/components/demos/shared/mock-text-conversation.vue';

export default {
    name: 'FlowDemo',

    components: {
        MockTextConversation
    },

    props: {
        heading: {
            type: String,
            default: 'Double Opt-In Process Demo'
        },

        technical_notes_heading: {
            type: String,
            default: 'Technical Implementation Notes'
        },

        form_data: {
            type: Object,
            required: true
        },

        conversation: {
            type: Array,
            default: () => []
        }
    },
}
</script>

<style lang="scss" scoped>
.double-opt-in-demo {
    --company-text-color: #E3F2FD;
    --customer-text-color: #C8E6C9;
    --technical-notes-bg: #F5F5F5;

    position: relative;
    text-align: center;
    max-width: min(1200px, 90%);
    margin: 3rem auto;
    padding: 2rem 2rem 3rem 2rem;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 1rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-top: 4px solid var(--v-primary-base);

    h3 {
        font-weight: 500;
    }

    .technical-notes {
        background-color: var(--technical-notes-bg);
        border-radius: 0.5rem;

        ul {
            padding-left: 1.2rem;
            list-style: none;
            text-align: left;

            li {
                margin-bottom: 0.5rem;
            }
        }
    }

    .v-btn--has-bg {
        color: rgba(255, 255, 255, 1);
    }
}
</style>